import { BackgroundBlockViewModel } from '../view-models/blocks/background-block.viewModel';
import { HowToArriveBlockViewModel } from '../view-models/blocks/how-to-arrive-block.viewModel';
import { PartnershipBannerBlockViewModel } from '../view-models/blocks/partnership-banner-block.viewModel';
import { PresentationSlideBlockViewModel } from '../view-models/blocks/presentation-slide-block.viewModel';
import { PromotedBlockViewModel } from '../view-models/blocks/promoted-block.viewModel';
import { SEOTextBlockViewModel } from '../view-models/blocks/seo-text-block.viewModel';
import { TextImageBlockViewModel } from '../view-models/blocks/text-image-block.viewModel';
import { TwoColumnsBlockViewModel } from '../view-models/blocks/two-columns-block.viewModel';

import type { CMSBlockViewModel } from '../types/cms-block.viewModel';
import type { CMSBlockType } from '@/src/cms/domain/types/cms-block.types';

export const cmsBlockPresentersMap = {
  'seo-text-block': SEOTextBlockViewModel.presenter,
  'text-image-block': TextImageBlockViewModel.presenter,
  'presentation-slide-block': PresentationSlideBlockViewModel.presenter,
  'background-block': BackgroundBlockViewModel.presenter,
  'promoted-block': PromotedBlockViewModel.presenter,
  'two-columns-block': TwoColumnsBlockViewModel.presenter,
  'how-to-arrive-block': HowToArriveBlockViewModel.presenter,
  'partnership-banner-block': PartnershipBannerBlockViewModel.presenter
} as const satisfies Record<
  CMSBlockType,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (block: any) => CMSBlockViewModel
>;
